import React, { useState } from "react";
import Row from '../components/Row';
import Divider from "../components/Divider";
// import Button from "../components/Button";
import { Link } from "react-router-dom";
import TitleUnderlined from "../components/TitleUnderlined";
import APIInterface from "../tools/APIInterface";
import { ShimmerContentBlock } from '../components/Shimmer'; 
import Event from "../models/Event";
// import ActivityItem from "../components/ActivityItem";
import TableEvent from "../components/TableEvent";
import { RoutesWeb } from "../tools/RoutesWeb";

const EventView = () => {
    const [event, setEvent] = useState(new Event());
    const [isLoaded, setIsLoaded] = useState(false);
    
    if(event._id === null){
        // console.log(isLoaded);
        APIInterface.event()
        .then((response) => {
            setEvent(response);
            setIsLoaded(true);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    return (
        <div className="pt-5 pb-5" id="eventView">
            <br></br>
            <br></br>
            <br></br>
            <Row>
                <div className="col-12 col-md-6">
                    <img className="img-1" src={require('../assets/IMG_Boletos-min-2.png')} alt="Img" />
                </div>
                <div className="col-12 col-md-6">
                    <TitleUnderlined>EJC, <span className="embercom_overlined">LIBRES</span></TitleUnderlined>
                    <br />
                    <br />
                    <p>Detalles del próximo evento</p>
                    <TableEvent isLoaded={isLoaded} event={event} />                    
                    <p className="mt-3">Realiza tu pago en línea con tarjeta débito o crédito mediante Paypal.</p>
                    {/* <p className="mt-3">Venta de boletos a partir del <b>lunes 17 de julio</b></p> */}
                    <br></br>                    
                    <Row className="justify-content-between">
                        <div className="col-12 col-md-6">
                            <Link className="btn btn-main" to="/detalles" style={{minWidth: '100%'}}>Efectuar donativo <img src={require('../assets/arrow_next.png')} alt="arrowNext" /></Link>
                            <Link className="lost-tickets-link" to={RoutesWeb.RESEND_TICKETS}>
                                ¿Extraviaste tus boletos?
                            </Link>
                        </div>
                        <div className="col-12 col-md-6 text-center">
                            <img src={require('../assets/Paypal_color.png')} style={{height: '50px'}} alt="paypal-logo"/>
                        </div>
                    </Row>
                </div>
            </Row>
            <Divider className="mt-5" />
            <h4 className="text-uppercase mt-4"><b>Información del evento</b></h4>
            {isLoaded ? 
                        <p className="mb-5 pb-4">{event.activities[0].description}</p>
                        :
                        <ShimmerContentBlock />
                    }
            {/* <table className="table">
                <thead>
                    <tr>
                        <th>Día</th>
                        <th>Actividad</th>
                        <th>Exponente</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoaded ? 
                        event.activities.map((activity, idx) => {
                            return <ActivityItem index={idx} activity={activity} />;
                        })
                        :
                        <ShimmerPostList/>
                    }
                </tbody>
            </table> */}
        </div>
    )
}

export default EventView;